/**
 * Campo de búsqueda con lupa. Un `<input>` pelado con un placeholder largo no
 * se lee como «aquí se busca», y además el texto se cortaba (Luis, 9 sep).
 * La lupa lo identifica de un vistazo y la ✕ permite vaciarlo sin seleccionar.
 */
import { useRef } from "react";
import type React from "react";

export default function SearchInput({
  value, onChange, placeholder, title, minWidth = 240, autoFocus = false, style,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  /** Texto completo al pasar el ratón, por si el placeholder no cabe. */
  title?: string;
  minWidth?: number;
  autoFocus?: boolean;
  /** Ajustes del contenedor: el Radar usa cápsula (radius 999) y más aire. */
  style?: React.CSSProperties;
}) {
  const ref = useRef<HTMLInputElement>(null);
  return (
    <div title={title ?? placeholder}
      style={{
        display: "flex", alignItems: "center", gap: 7, minWidth, flex: "1 1 auto", maxWidth: 420,
        background: "var(--clr-input-bg)", border: "1px solid var(--clr-border)",
        borderRadius: 12, padding: "6px 10px", boxSizing: "border-box", ...style,
      }}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth={1.9} strokeLinecap="round" aria-hidden
        style={{ color: "var(--clr-text4)", flexShrink: 0 }}>
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3.6-3.6" />
      </svg>
      <input
        ref={ref}
        autoFocus={autoFocus}
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
        style={{
          flex: 1, minWidth: 0, background: "transparent", border: "none", outline: "none",
          color: "var(--clr-text)", fontSize: "0.82rem", padding: 0,
        }} />
      {value && (
        <button type="button" aria-label="Limpiar"
          onClick={() => { onChange(""); ref.current?.focus(); }}
          style={{
            background: "transparent", border: "none", cursor: "pointer", padding: 0,
            display: "inline-flex", color: "var(--clr-text4)", flexShrink: 0,
          }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth={1.8} strokeLinecap="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
        </button>
      )}
    </div>
  );
}
